import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "./legal.css";
import { NavLink } from "react-router-dom";

export default function Legal() {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        <div data-aos="fade-up" className="legal-container">
            <h1 className="legal-title">Legal & Policies</h1>
            <p className="legal-description">
                To find the document applicable to you under the agreement between you and FixerFind,
                check the section below for the method you are using FixerFind services in.
            </p>

            <div className="legal-links">
                <NavLink to="/legal/privacy-policy" className="legal-link" onClick={scrollToTop}>
                    General Privacy Policy
                </NavLink>
                <NavLink to="/legal/customer-term" className="legal-link" onClick={scrollToTop}>
                    Terms of Use for Customers
                </NavLink>
                <NavLink to="/legal/service-provider-term" className="legal-link" onClick={scrollToTop}>
                    Terms of Use for Service Providers
                </NavLink>
            </div>
        </div>
    );
}
